import { useTranslation } from 'react-i18next'
import CardTemplate from './card-template'

const SubmittedCredit = ({ children, ...props }) => {
  const { t } = useTranslation()

  const creditDescription = t(
    'r.trust_score.trust_score_complete.text',
    "You're all set! Your Trust Score information is complete. Your Trust Score report will now be available to landlords whose units you apply to once it's been analyzed by the liv.rent team."
  )

  return (
    <CardTemplate
      userRole={props.userRole}
      title={props.title}
      creditDescription={creditDescription}
      creditRatingResult={t('r.trust_score.completed.text', 'Completed')}
      creditDetails={props.creditDetails}
      user={props.user}
      professionId={props.professionId}
      csoVerifiedState={props.csoVerifiedState}
      salarySort={props.salarySort}
      listingData={props.listingData}
      showDetails={props.showDetails}
      secureFiles={props.secureFiles}
      noDetails
      data-testid={props['data-testid']}
    >
      {children}
    </CardTemplate>
  )
}

SubmittedCredit.defaultProps = {
  userRole: 'tenant',
  title: ''
}

export default SubmittedCredit
